export default "__VITE_ASSET__BcIRvlNq__"